import * as React from 'react';
import { Icon, ICON_NAME } from 'components/icon'; 
import TEXT_KEYS from '../progress-block.constants';
import './progress-block-expand-button.styles.less';
import { getModeClass } from 'utils/css';

const ProgressBlockExpandButton: React.FC<IProgressBlockExpandButtonProps> = ({
    iconName,
    text,
    onClick,
    shouldInheritStyles
}) => {
    const basePageStyleClass = getModeClass('sitegen-friend-referral-progress-expand-button', shouldInheritStyles);
    return (
        <div className={basePageStyleClass} onClick={onClick}>
            <span className={`${basePageStyleClass}__text`}>
                { text }
            </span>
            <Icon name={ iconName } />
        </div>
    );
};

type IProgressBlockExpandButtonProps = {
    readonly onClick: () => void,
    readonly iconName: ICON_NAME,
    readonly text: string,
    readonly shouldInheritStyles: boolean
};

export default ProgressBlockExpandButton;
export {
    Icon,
    TEXT_KEYS,
    ICON_NAME,
    IProgressBlockExpandButtonProps
};
